var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["createPortal"]: () => (__WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__.createPortal), ["default"]: () => (__WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__["default"]) });